import React from "react";
const ContactDetails = () => <section>hey i'm ContactDetails</section>;
export default ContactDetails;
